import React from 'react';
import { SvgIcon } from '@mui/material';

function RadioButtonSelected(props) {
  return (
    <SvgIcon {...props}>
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#3448FF"
          d="M7 3.667a3.335 3.335 0 000 6.666 3.335 3.335 0 000-6.666zM7 .333A6.67 6.67 0 00.333 7 6.67 6.67 0 007 13.667 6.67 6.67 0 0013.666 7 6.669 6.669 0 007 .333zm0 12A5.332 5.332 0 011.666 7 5.332 5.332 0 017 1.667 5.332 5.332 0 0112.333 7 5.332 5.332 0 017 12.333z"
        ></path>
      </svg>
    </SvgIcon>
  );
}

export default RadioButtonSelected;
